import React from 'react';
import iubatLogo from '../../image/Iubat-logo.png';
import './Education.css'
const Education = () => {
    return (
        <div className='container mt-5'>
            <div className='row'>
                <div className='col-md-7 eduSection' data-aos="fade-right">
                    <h2 className='my-4 fw-bold font-monospace'>Education</h2>
                    <img src={iubatLogo} alt="" className='' style={{width: "75px"}} />
                    <h4 className='fw-bold'> International University of Business Agriculture and Technology </h4>
                    <p>Bachelor of Computer Science and Engineering </p>
                    <p> September 2015 - April 2020 </p>
                </div>
            </div>
        </div>
    );
};

export default Education;